import { Icon, Tooltip } from 'antd';
import React from 'react';
import styles from './ChessIcon.module.scss';
import { ReactComponent as LayoutIcon } from '../../../../../resource/Layout.svg';

const chessType = {
  allowChess: true,
  notAllowChess: false,
};

const iconComponents = {
  [chessType.allowChess]: (props) => (
    <Icon type="check" style={{ fontSize: 20 }} {...props} />
  ),
  [chessType.notAllowChess]: (props) => (
    <Icon type="close" style={{ fontSize: 20 }} {...props} />
  ),
};

const ChessIcon = ({ existLayout }) => {
  const Component = iconComponents[existLayout];

  const title = existLayout ? 'Есть шахматка' : 'Нет шахматки';

  return Component ? (
    <Tooltip title={title}>
      <div className={styles.root}>
        <Component className={styles.icon} />
      </div>
    </Tooltip>
  ) : null;
};

export default ChessIcon;
